import SectionBanner from "components/cards/SectionBanner";
import EditAnnouncement from "./EditAnnouncement";
import IMGAnnouncementExample from "assets/images/announcementexample.jpg";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import SettingService from "api/services/SettingService";
import ToggleSwitch from 'components/actions/ToggleSwitch'
import { useHistory } from "react-router-dom";
import SectionWrapper from "components/wrappers/SectionWrapper";
import ToastAlert from "components/ToastAlert";
import CreateAnnouncement from "./CreateAnnouncement";
import DashboardWrapper from "components/wrappers/DashboardWrapper";
import OnDeleteConfirm from "components/modals/OnDeleteConfirm";
import Language from "components/Language";
import PropTypes from 'prop-types';

function Announcements() {
  const { t } = useTranslation();
  const [remoteData, setRemoteData] = useState([])
  const [updateStatus, setUpdateStatus] = useState(null)
  const history = useHistory()

  useEffect(() => {
    SettingService.getAnnouncementMsg().then((resp) => {
      setRemoteData(resp)
    }).catch((err) => {
      //Handle error ..
    });
  }, []);

  const onUpdate = (data) => {
    const id = remoteData[0]?.id;
    SettingService.updateAnnouncementMsg(id, data).then((resp) => {
      history.go();
      setUpdateStatus('success')
    }).catch((err) => {
      //Handle error ..
      setUpdateStatus('error')

    });
  }

  const onCreate = (data) => {
    SettingService.createAnnouncementMsg(data).then((resp) => {
      history.go();
      setUpdateStatus('success')
    }).catch((err) => {
      //Handle error ..
      setUpdateStatus('error')
    });
  }

  const onDelete = (id) => {
    if (id) {
      SettingService.deleteAnnouncementMsg(id).then((resp) => {
        history.go();
        setUpdateStatus('success')
      }).catch((err) => {
        //Handle error ..
        setUpdateStatus('error')
      });
    }
  }

  return (
    <DashboardWrapper>
      <div>
        <SectionBanner
          title={t('announcements.title')}
          desc={t('announcements.description')}
        >
          <img src={IMGAnnouncementExample} alt='' height='' width='320px' />
        </SectionBanner>

        <SectionWrapper
          title={t('announcements.title')}
          actions={
            <div className="flex gap-2">
              <EditAnnouncement data={remoteData[0]} onDataUpdate={onUpdate} disabled={(remoteData?.length < 1)} />
              {(remoteData?.length < 1) ?
                <CreateAnnouncement onCreate={onCreate} />
                :
                <OnDeleteConfirm onConfirm={() => onDelete(remoteData[0].id)} key={"d3-1"} />
              }
            </div>
          }
          className="bg-white"
        >
          <div className="">
            <AnnouncementMessage message={remoteData[0]} />
          </div>

        </SectionWrapper>

        {updateStatus === "success" && <ToastAlert message={t('alert.success_operation')} type={'success'} timeOut={5000} />}
        {updateStatus === "error" && <ToastAlert message={t('alert.failed_operation')} type={'error'} timeOut={5000} />}

      </div>


    </DashboardWrapper>

  );
}

export default Announcements;

const AnnouncementMessage = ({ message }) => {
  const id = message?.id;
  const [data] = useState(message)
  const history = useHistory()
  const [updateStatus, setUpdateStatus] = useState(null)
  const { t } = useTranslation()


  const onChangeMenuStatus = (_isEnabled) => {
    let _data = {
      ...data,
      enabled: _isEnabled
    }
    if (id && _data) {
      SettingService.updateAnnouncementMsg(id, _data).then((resp) => {
        history.go();
        setUpdateStatus("success")
      }).catch((err) => {
        //Handle error ..
        setUpdateStatus("error")

      });
    }


  }


  return (

    <>
      {
        !!message &&
        <div className="border rounded p-4">
          <div className="flex justify-end">
            <ToggleSwitch isEnabled={onChangeMenuStatus} enabled={message?.enabled} />
          </div>
          <div className="flex  items-center py-2">
            <Language showKeyOnly _key="fr" />
            <span className="mx-4">{message?.french}</span>
          </div>
          <div className="flex  items-center py-2  ">
            <Language showKeyOnly _key="ar" />
            <span className="mx-4">{message?.arabic}</span>
          </div>
          {/* <div className="flex  items-center py-2  ">
            <Language  showKeyOnly _key="ar_ma" />
            <span className="mx-4">{message?.arabic_dialect_ma}</span>
          </div> */}
          <div className="flex  items-center py-2 ">
            <Language showKeyOnly _key="en" />
            <span className="mx-4">{message?.english}</span>
          </div>

        </div>

      }

      {updateStatus === "success" && <ToastAlert message={t('alert.success_operation')} type={'success'} timeOut={5000} />}
      {updateStatus === "error" && <ToastAlert message={t('alert.failed_operation')} type={'error'} timeOut={5000} />}

    </>
  );




}


AnnouncementMessage.propTypes = {
  message: PropTypes.object,
};
